import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse } from "../common";
import { ImageInfo } from "./imageSlice";
import { getToken } from "../../features/user/UserAvatar";
import { ObjectTarget } from "../../app/permissions";

export interface ImageInsState {
  state: LoadStateInfo;
  image: ImageInfo;
}

const initialState: ImageInsState = {
  state:notStarted(),
  image: emptyImage(),
};

function emptyImage() {
  return {
    id: "",
    schoolId: "",
    name: "",
    photoURL: "",
  };
}

export interface ImageInsTargetRequest {
  schoolId: string;
  avatar: boolean;
  objectTarget?: ObjectTarget;
  targetId?: string;
  conversationId?: string;
  partyId?: string;
  additionalObjectTarget?: ObjectTarget;
  additionalTargetId?: string;
}

export interface ImageInsRequest {
  file: File;
  target: ImageInsTargetRequest;
}

export const imageInsert = createAsyncThunk(
  "imageInsert",
  async (param: ImageInsRequest, thunkAPI) => {
    console.debug("insert image");

    let queryParams = `filename=${param.file.name}`;
    queryParams += `&schoolId=${param.target.schoolId}`;
    queryParams += `&avatar=${param.target.avatar}`;
    queryParams += `&objectTarget=${param.target.objectTarget}`;
    queryParams += `&targetId=${param.target.targetId}`;
    const response = await fetch(`${getBackendUrl()}/api/image?${queryParams}`, {
      method: "POST",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": `${param.file.type}`,
      },
      body: param.file
    });

    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);


export const imageInsSlice = createSlice({
  name: "imageInsSlice",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    set: (state, action: PayloadAction<ImageInfo>) => {
      state.state = notStarted();
      state.image = action.payload;
    },
    clean: (state) => {
      state.state = notStarted();
      state.image = emptyImage();
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(imageInsert.pending, (state, action) => {
        state.state =  loading();
      })
      .addCase(imageInsert.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
        state.image = action.payload;
      })
      .addCase(imageInsert.rejected, (state, action) => {
        state.state = error(action);
      });
    },
});

export const { } = imageInsSlice.actions;

export const selectImageIns = (state: RootState) => state.imageIns;

export default imageInsSlice.reducer;
